(function () {
  /* Allows mobile gallery swipes to continue across video slides. */
  var root = document.querySelector('[data-strikeman-product-page]');
  if (!root) return;

  function alignGalleryControls() {
    var gallery = root.querySelector('.spp-gallery-card');
    var media = root.querySelector('.spp-main-media');
    if (!gallery || !media) return;
    function updateControlCenter() {
      var item = media.querySelector('.spp-main-image, .spp-main-video');
      if (!item) return;
      var bounds = item.getBoundingClientRect();
      var sourceWidth = item.naturalWidth || item.videoWidth || bounds.width;
      var sourceHeight = item.naturalHeight || item.videoHeight || bounds.height;
      if (!sourceWidth || !sourceHeight) return;
      var paintedHeight = Math.min(bounds.height, bounds.width * sourceHeight / sourceWidth);
      var center = bounds.top - gallery.getBoundingClientRect().top + paintedHeight / 2;
      gallery.style.setProperty('--spp-gallery-control-center', center + 'px');
    }
    media.addEventListener('load', updateControlCenter, true);
    media.addEventListener('loadedmetadata', updateControlCenter, true);
    if (window.ResizeObserver) {
      var sizeObserver = new ResizeObserver(updateControlCenter);
      sizeObserver.observe(gallery);
      sizeObserver.observe(media);
    } else {
      window.addEventListener('resize', updateControlCenter);
    }
    var mediaObserver = new MutationObserver(updateControlCenter);
    mediaObserver.observe(media, { childList: true });
    updateControlCenter();
  }

  alignGalleryControls();


  function injectGalleryArrowStyle() {
    if (document.getElementById('strikeman-product-gallery-arrow-style')) return;
    var style = document.createElement('style');
    style.id = 'strikeman-product-gallery-arrow-style';
    style.textContent = [
      '.spp-gallery-card .spp-main-media{margin-right:52px;}',
      '.spp-gallery-card .spp-gallery-arrow{z-index:4;}',
      '.spp-gallery-card .spp-gallery-arrow--prev{left:88px;}',
      '.spp-gallery-card .spp-gallery-arrow--next{right:18px;}',
      '@media screen and (max-width:749px){.spp-gallery-card .spp-main-media{margin-right:-15px;}.spp-gallery-card .spp-gallery-arrow{display:none;}}'
    ].join('');
    document.head.appendChild(style);
  }

  injectGalleryArrowStyle();

  var defaultRecommendation = 'Select a caliber to see firearm-specific fit guidance before you add this kit to cart.';
  var pistolRestriction = 'Restrictions: Ruger SR, Walther PPK/PPK/S/CCP, Beretta AX100, and Beretta 92X Centurion need SmartShot or support review.';
  var rifleRestriction = 'Restrictions: Marlin 336, Winchester Model 54, and Savage 110 are not compatible with standard lasers.';
  var recommendationCopy = {
    '9mm': 'Works with most 9mm pistols. ' + pistolRestriction,
    '380': 'Works with most .380 ACP pistols. ' + pistolRestriction,
    '380acp': 'Works with most .380 ACP pistols. ' + pistolRestriction,
    '380 acp': 'Works with most .380 ACP pistols. ' + pistolRestriction,
    '.380 acp': 'Works with most .380 ACP pistols. ' + pistolRestriction,
    '10mm': 'Works with most 10mm pistols. ' + pistolRestriction,
    '40sw': 'Works with most .40 S&W pistols. ' + pistolRestriction,
    '.40 sw': 'Works with most .40 S&W pistols. ' + pistolRestriction,
    '.40 sandw': 'Works with most .40 S&W pistols. ' + pistolRestriction,
    '.40 s&w': 'Works with most .40 S&W pistols. ' + pistolRestriction,
    '40sandw': 'Works with most .40 S&W pistols. ' + pistolRestriction,
    '45acp': 'Works with most .45 ACP pistols. ' + pistolRestriction,
    '.45 acp': 'Works with most .45 ACP pistols. ' + pistolRestriction,
    '45 colt': 'Works with most .45 Colt firearms. Confirm whether your setup is a pistol or revolver before ordering. ' + pistolRestriction,
    '.45 colt': 'Works with most .45 Colt firearms. Confirm whether your setup is a pistol or revolver before ordering. ' + pistolRestriction,
    '357sig': 'Works with most .357 SIG pistols. ' + pistolRestriction,
    '.357 sig': 'Works with most .357 SIG pistols. ' + pistolRestriction,
    '223556': 'Works with most .223 / 5.56 rifles. SmartShot is the best-fit recommendation for .223 / 5.56 setups. ' + rifleRestriction,
    '223': 'Works with supported .223 / 5.56 rifles. SmartShot is the best-fit recommendation for .223 / 5.56 setups. ' + rifleRestriction,
    '223/556': 'Works with most .223 / 5.56 rifles. SmartShot is the best-fit recommendation for .223 / 5.56 setups. ' + rifleRestriction,
    '223/5.56': 'Works with most .223 / 5.56 rifles. SmartShot is the best-fit recommendation for .223 / 5.56 setups. ' + rifleRestriction,
    '.223/5.56': 'Works with most .223 / 5.56 rifles. SmartShot is the best-fit recommendation for .223 / 5.56 setups. ' + rifleRestriction,
    '303': 'Works with most .303 British rifles. ' + rifleRestriction,
    '303 british': 'Works with most .303 British rifles. ' + rifleRestriction,
    '308': 'Works with most .308 / 7.62x51mm rifles. ' + rifleRestriction,
    '243/308 win': 'Works with most .243 / .308 WIN rifles. ' + rifleRestriction,
    '30-30': 'Works with most 30-30 rifles. ' + rifleRestriction,
    '243': 'Works with most .243 rifles. ' + rifleRestriction,
    '.243': 'Works with most .243 rifles. ' + rifleRestriction,
    '30-06': 'Works with most 30-06 rifles. ' + rifleRestriction,
    '.30-06': 'Works with most 30-06 rifles. ' + rifleRestriction,
    '3006': 'Works with most 30-06 rifles. ' + rifleRestriction,
    '7.62x51mm': 'Works with most 7.62x51mm rifles. ' + rifleRestriction,
    '7.62 x51mm': 'Works with most 7.62x51mm rifles. ' + rifleRestriction,
    '6.5 crdmr': 'Works with most 6.5 Creedmoor rifles. ' + rifleRestriction,
    '6.5 mmc': 'Works with most 6.5 Creedmoor rifles. ' + rifleRestriction,
    '300 aac': 'Works with most .300 AAC rifles. ' + rifleRestriction,
    '.300 aac': 'Works with most .300 AAC rifles. ' + rifleRestriction,
    '300aac': 'Works with most .300 AAC rifles. ' + rifleRestriction,
    '12 gauge': 'Works only with compatible 12 Gauge shotguns. Confirm your shotgun is chambered for 12 Gauge; if not, do not select this cartridge.',
    '38 special': 'For .38 Special / .357 Magnum revolvers, use the dedicated revolver cartridge 5-pack with the Target & Phone Mount instead of the Standard Kit path.',
    '.38 special': 'For .38 Special / .357 Magnum revolvers, use the dedicated revolver cartridge 5-pack with the Target & Phone Mount instead of the Standard Kit path.'
  };

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9./ -]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function compact(value) {
    return normalize(value).replace(/[^a-z0-9]/g, '');
  }

  function recommendationFor(label) {
    var normalized = normalize(label);
    var compressed = compact(label);
    return recommendationCopy[normalized] || recommendationCopy[compressed] || 'Works with most ' + label + ' firearms. Some firearm models may require a different laser. Confirm fit before purchase.';
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function formatRecommendation(copy) {
    var text = String(copy || '').trim();
    var isPistol = text.indexOf(pistolRestriction) !== -1;
    var isRifle = text.indexOf(rifleRestriction) !== -1;
    if (!isPistol && !isRifle) return escapeHtml(text);
    var intro = text.split(isPistol ? pistolRestriction : rifleRestriction)[0].trim();
    var compatible = [];
    var restrictions = [];
    if (isPistol) {
      if (/^Works with most (9mm|\.380 ACP)/.test(intro)) {
        compatible.push(['S&W M&P Shield 9mm', 'Compatible with both 9mm and .380 ACP standard laser cartridges.']);
        restrictions.push(['Girsan 9mm', 'Use a .380 ACP laser cartridge.']);
        restrictions.push(['Tanfoglio 9mm', 'Use a .380 ACP laser cartridge.']);
      }
      restrictions.push(['Ruger SR series', 'Not compatible with standard cartridges. Use SmartShot in the appropriate caliber.']);
      restrictions.push(['Walther PPK / PPK/S', 'Not compatible with standard cartridges. Use SmartShot in the appropriate caliber.']);
      restrictions.push(['Walther CCP', 'Not compatible with standard cartridges. SmartShot compatibility is unconfirmed.*']);
      restrictions.push(['Beretta AX100', 'Standard-cartridge exception.*']);
      restrictions.push(['Beretta 92X Centurion', 'Standard-cartridge exception.*']);
    } else {
      ['Marlin 336', 'Winchester Model 54', 'Savage 110'].forEach(function (model) {
        restrictions.push([model, 'Not compatible with standard laser cartridges.*']);
      });
    }
    function renderList(items) {
      if (!items.length) return '';
      return '<ul class="spp-compatibility-list">' + items.map(function (item) {
        return '<li><strong>' + escapeHtml(item[0]) + ':</strong> ' + escapeHtml(item[1]) + '</li>';
      }).join('') + '</ul>';
    }
    return '<span>' + escapeHtml(intro) + '</span>' + renderList(compatible) +
      '<h3 class="spp-restrictions-title">Restrictions</h3>' + renderList(restrictions) +
      '<p class="spp-compatibility-footnote">* Contact support before ordering.</p>';
  }

  function addClass(node, className) {
    if (!node) return;
    var classes = String(node.getAttribute('class') || '').split(/\s+/).filter(Boolean);
    if (!classes.includes(className)) classes.push(className);
    node.setAttribute('class', classes.join(' '));
  }

  function removeClass(node, className) {
    if (!node) return;
    node.setAttribute('class', String(node.getAttribute('class') || '')
      .split(/\s+/)
      .filter(function (item) { return item && item !== className; })
      .join(' '));
  }

  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-spp-thumb]'));
  var currentMediaIndex = 0;
  var mobileGalleryQuery = window.matchMedia('(max-width: 749px)');

  function closeImageModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('spp-image-modal-open');
    var image = modal.querySelector('[data-spp-image-modal-img]');
    if (image) image.removeAttribute('src');
  }

  function getImageModal() {
    var modal = document.querySelector('[data-spp-image-modal]');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'spp-image-modal';
    modal.setAttribute('data-spp-image-modal', '');
    modal.hidden = true;
    modal.innerHTML = [
      '<button class="spp-image-modal__backdrop" type="button" data-spp-image-modal-close aria-label="Close image preview"></button>',
      '<div class="spp-image-modal__dialog" role="dialog" aria-modal="true" aria-label="Product image preview">',
      '<button class="spp-image-modal__close" type="button" data-spp-image-modal-close>Close</button>',
      '<img class="spp-image-modal__image" data-spp-image-modal-img alt="">',
      '</div>'
    ].join('');
    document.body.appendChild(modal);

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-spp-image-modal-close]')) closeImageModal(modal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeImageModal(modal);
    });

    return modal;
  }

  function openImageModal(src, alt) {
    if (!src) return;
    var modal = getImageModal();
    var image = modal.querySelector('[data-spp-image-modal-img]');
    if (!image) return;
    image.src = src;
    image.alt = alt || 'Product image';
    modal.hidden = false;
    modal.classList.add('is-open');
    document.documentElement.classList.add('spp-image-modal-open');
    var close = modal.querySelector('.spp-image-modal__close');
    if (close) close.focus({ preventScroll: true });
  }

  function setActiveMedia(index) {
    if (!thumbs.length) return;
    if (index < 0) index = thumbs.length - 1;
    if (index >= thumbs.length) index = 0;
    currentMediaIndex = index;

    var thumb = thumbs[index];
    var mainMedia = root.querySelector('.spp-main-media');
    if (!thumb || !mainMedia) return;

    var alt = thumb.dataset.alt || '';
    if (thumb.dataset.mediaType === 'video' && thumb.dataset.videoSrc) {
      mainMedia.innerHTML = [
        '<video class="spp-main-video" controls playsinline preload="metadata" poster="' + (thumb.dataset.src || '') + '">',
        '<source src="' + thumb.dataset.videoSrc + '" type="video/mp4">',
        '</video>'
      ].join('');
    } else if (thumb.dataset.src) {
      mainMedia.innerHTML = '<img class="spp-main-image" src="' + thumb.dataset.src + '" alt="' + alt.replace(/"/g, '&quot;') + '" data-spp-main-image>';
    }

    thumbs.forEach(function (item, itemIndex) {
      item.classList.toggle('is-active', itemIndex === index);
    });

    root.querySelectorAll('.spp-gallery-dots span').forEach(function (dot, dotIndex) {
      dot.classList.toggle('is-active', dotIndex === index);
      dot.hidden = dotIndex >= thumbs.length;
    });

    var count = root.querySelector('.spp-gallery-count');
    if (count) count.textContent = (index + 1) + ' / ' + thumbs.length;
  }

  function setButtonsEnabled(enabled, available) {
    root.querySelectorAll('[data-spp-add]').forEach(function (button) {
      if (!enabled) {
        button.disabled = false;
        button.type = 'button';
        button.setAttribute('data-spp-needs-caliber', 'true');
        button.textContent = button.dataset.sppDisabledLabel || button.dataset.sppReadyLabel || 'Add to cart';
      } else if (!available) {
        button.disabled = true;
        button.type = 'submit';
        button.removeAttribute('data-spp-needs-caliber');
        button.textContent = 'Sold out';
      } else {
        button.disabled = false;
        button.type = 'submit';
        button.removeAttribute('data-spp-needs-caliber');
        button.textContent = button.dataset.sppReadyLabel || 'Add to cart';
      }
    });
  }

  var caliberAttentionTimer;
  var pendingAddForm = null;

  function submitPendingAddAfterCaliber(select) {
    if (!pendingAddForm || !select || !select.value) return;

    var option = select.options[select.selectedIndex];
    if (option && option.dataset.available === 'false') {
      pendingAddForm = null;
      return;
    }

    var form = pendingAddForm;
    pendingAddForm = null;

    window.setTimeout(function () {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
        return;
      }

      var submitEvent = new Event('submit', { bubbles: true, cancelable: true });
      if (form.dispatchEvent(submitEvent)) form.submit();
    }, 80);
  }
  function applyCaliberAttention(select) {
    var shell = select.closest('[data-spp-caliber-shell]');
    addClass(shell, 'is-attention');
    addClass(select, 'is-attention');
    select.style.borderColor = 'transparent';
    select.style.borderWidth = '1px';
    select.style.outline = 'none';
    select.style.boxShadow = 'none';
  }

  function clearCaliberAttention(select) {
    var shell = select.closest('[data-spp-caliber-shell]');
    removeClass(shell, 'is-attention');
    removeClass(select, 'is-attention');
    select.style.borderColor = '';
    select.style.borderWidth = '';
    select.style.outline = '';
    select.style.boxShadow = '';
  }

  function ensureCustomSelect() {
    var select = root.querySelector('[data-spp-caliber-select]');
    if (!select) return null;

    var shell = select.closest('[data-spp-caliber-shell]');
    if (!shell) return null;

    Array.prototype.slice.call(select.options).forEach(function (nativeOption) {
      if (nativeOption.value && nativeOption.dataset.available === 'false') nativeOption.remove();
    });

    var availableValues = Array.prototype.slice.call(select.options).map(function (nativeOption) {
      return nativeOption.value;
    });

    if (!shell.querySelector('[data-spp-select-toggle]')) {
      var toggle = document.createElement('button');
      var label = document.createElement('span');
      var icon = document.createElement('span');
      var menuId = (select.id || 'spp-caliber') + '-menu';

      toggle.className = 'spp-select-toggle';
      toggle.type = 'button';
      toggle.setAttribute('data-spp-select-toggle', '');
      toggle.setAttribute('aria-haspopup', 'listbox');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', menuId);

      label.setAttribute('data-spp-select-label', '');
      label.textContent = select.value ? select.options[select.selectedIndex].textContent.trim() : 'Select caliber';
      icon.className = 'spp-select-toggle__icon';
      icon.setAttribute('aria-hidden', 'true');

      toggle.appendChild(label);
      toggle.appendChild(icon);
      select.insertAdjacentElement('afterend', toggle);
    }

    shell.querySelectorAll('[data-spp-select-option]').forEach(function (option) {
      if (availableValues.indexOf(option.dataset.value) === -1) option.remove();
    });

    if (!shell.querySelector('[data-spp-select-menu]')) {
      var menu = document.createElement('div');
      menu.className = 'spp-select-menu';
      menu.id = shell.querySelector('[data-spp-select-toggle]').getAttribute('aria-controls');
      menu.setAttribute('data-spp-select-menu', '');
      menu.setAttribute('role', 'listbox');
      menu.hidden = true;

      Array.prototype.slice.call(select.options).forEach(function (nativeOption) {
        if (!nativeOption.value) return;
        if (nativeOption.dataset.available === 'false') return;
        var option = document.createElement('button');
        option.className = 'spp-select-option';
        option.type = 'button';
        option.setAttribute('role', 'option');
        option.setAttribute('data-spp-select-option', '');
        option.setAttribute('data-value', nativeOption.value);
        option.setAttribute('data-label', nativeOption.textContent.trim());
        option.setAttribute('aria-selected', 'false');
        option.textContent = nativeOption.textContent.trim();
        menu.appendChild(option);
      });

      shell.appendChild(menu);
    }

    return shell;
  }

  function syncCustomSelect() {
    var select = root.querySelector('[data-spp-caliber-select]');
    var shell = ensureCustomSelect();
    if (!select || !shell) return;

    var label = shell.querySelector('[data-spp-select-label]');
    var selectedOption = select.options[select.selectedIndex];
    var selectedText = selectedOption && select.value ? selectedOption.textContent.trim() : 'Select caliber';

    if (label) label.textContent = selectedText;
    shell.querySelectorAll('[data-spp-select-option]').forEach(function (option) {
      option.setAttribute('aria-selected', option.dataset.value === select.value ? 'true' : 'false');
    });
  }

  function openCustomSelect() {
    var shell = ensureCustomSelect();
    if (!shell) return;

    var toggle = shell.querySelector('[data-spp-select-toggle]');
    var menu = shell.querySelector('[data-spp-select-menu]');
    if (!toggle || !menu) return;

    addClass(shell, 'is-open');
    menu.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    toggle.focus({ preventScroll: true });
  }

  function closeCustomSelect() {
    var shell = root.querySelector('[data-spp-caliber-shell]');
    if (!shell) return;

    var toggle = shell.querySelector('[data-spp-select-toggle]');
    var menu = shell.querySelector('[data-spp-select-menu]');
    removeClass(shell, 'is-open');
    if (menu) menu.hidden = true;
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function chooseCustomSelectOption(option) {
    var select = root.querySelector('[data-spp-caliber-select]');
    if (!select || !option) return;

    select.value = option.dataset.value || '';
    select.dispatchEvent(new Event('change', { bubbles: true }));
    closeCustomSelect();
  }

  function guideCaliberSelection() {
    var select = root.querySelector('[data-spp-caliber-select]');
    if (!select) return;

    clearTimeout(caliberAttentionTimer);
    applyCaliberAttention(select);
    select.scrollIntoView({ behavior: 'smooth', block: 'center' });
    openCustomSelect();

    caliberAttentionTimer = window.setTimeout(function () {
      if (!select.value) clearCaliberAttention(select);
    }, 3000);
  }

  window.strikemanGuideCaliberSelection = function (event, button) {
    if (!button || !button.hasAttribute('data-spp-needs-caliber')) return true;
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    pendingAddForm = button.closest('form') || root.querySelector('form[data-spp-product-form]');
    guideCaliberSelection();
    return false;
  };

  function updateSelectedVariant() {
    var select = root.querySelector('[data-spp-caliber-select]');
    if (!select) return;
    ensureCustomSelect();
    var option = select.options[select.selectedIndex];
    var variantId = option && option.value ? option.value : '';
    var isSelected = !!variantId;
    var caliber = isSelected ? (option.dataset.caliber || option.textContent.trim()) : '';
    var recommendation = root.querySelector('[data-spp-recommendation]');
    var sale = root.querySelector('[data-spp-sale]');
    var compare = root.querySelector('[data-spp-compare]');

    root.querySelectorAll('[data-spp-variant-input]').forEach(function (input) {
      input.value = variantId;
    });

    if (recommendation) recommendation.innerHTML = isSelected ? formatRecommendation(recommendationFor(caliber)) : escapeHtml(defaultRecommendation);

    if (isSelected && sale && option.dataset.price) sale.textContent = option.dataset.price;
    if (isSelected && compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }

    setButtonsEnabled(isSelected, !option || option.dataset.available !== 'false');
    syncCustomSelect();

    if (isSelected && option.dataset.image) {
      var imageIndex = thumbs.findIndex(function (thumb) {
        return thumb.dataset.src === option.dataset.image;
      });
      if (imageIndex >= 0) setActiveMedia(imageIndex);
    }
  }

  root.addEventListener('change', function (event) {
    if (event.target.matches('[data-spp-caliber-select]')) {
      if (event.target.value) clearCaliberAttention(event.target);
      updateSelectedVariant();
      submitPendingAddAfterCaliber(event.target);
    }
  });

  root.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-spp-select-toggle]');
    if (toggle && root.contains(toggle)) {
      event.preventDefault();
      var shell = toggle.closest('[data-spp-caliber-shell]');
      if (shell && shell.classList.contains('is-open')) closeCustomSelect();
      else openCustomSelect();
      return;
    }

    var option = event.target.closest('[data-spp-select-option]');
    if (option && root.contains(option)) {
      event.preventDefault();
      chooseCustomSelectOption(option);
    }
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest || target.closest('[data-spp-caliber-shell]')) return;
    closeCustomSelect();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCustomSelect();
  });

  function handleNeedsCaliberAction(event) {
    var button = event.target.closest('[data-spp-add][data-spp-needs-caliber="true"]');
    if (!button || !root.contains(button)) return;
    event.preventDefault();
    event.stopPropagation();
    pendingAddForm = button.closest('form') || root.querySelector('form[data-spp-product-form]');
    guideCaliberSelection();
  }

  root.addEventListener('pointerdown', handleNeedsCaliberAction, true);
  root.addEventListener('click', handleNeedsCaliberAction, true);

  root.addEventListener('click', function (event) {
    var mainImage = event.target.closest('.spp-main-image');
    if (mainImage && root.contains(mainImage)) {
      event.preventDefault();
      openImageModal(mainImage.currentSrc || mainImage.src, mainImage.alt);
      return;
    }

    var thumb = event.target.closest('[data-spp-thumb]');
    if (thumb) {
      var index = thumbs.indexOf(thumb);
      if (index >= 0) setActiveMedia(index);
      return;
    }

    if (event.target.closest('[data-spp-gallery-prev]')) {
      setActiveMedia(currentMediaIndex - 1);
      return;
    }

    if (event.target.closest('[data-spp-gallery-next]')) {
      setActiveMedia(currentMediaIndex + 1);
      return;
    }

    var qtyRoot = event.target.closest('[data-spp-qty]');
    if (!qtyRoot) return;
    var input = qtyRoot.querySelector('[data-spp-qty-input]');
    if (!input) return;
    var value = Math.max(1, parseInt(input.value || '1', 10));
    if (event.target.closest('[data-spp-qty-minus]')) value -= 1;
    if (event.target.closest('[data-spp-qty-plus]')) value += 1;
    input.value = Math.max(1, value);
    syncQuantities(input.value);
  });

  var gallery = root.querySelector('[data-spp-gallery]');
  if (gallery) {
    var swipeStartX = 0;
    var swipeStartY = 0;
    var swipeLastX = 0;
    var swipeLastY = 0;
    var isGallerySwipe = false;

    function shouldIgnoreGallerySwipe(target) {
      return !!target.closest('[data-spp-thumb], [data-spp-gallery-prev], [data-spp-gallery-next], button, a, input, select, textarea');
    }

    gallery.addEventListener('touchstart', function (event) {
      if (!mobileGalleryQuery.matches || event.touches.length !== 1 || shouldIgnoreGallerySwipe(event.target)) return;
      var touch = event.touches[0];
      swipeStartX = touch.clientX;
      swipeStartY = touch.clientY;
      swipeLastX = swipeStartX;
      swipeLastY = swipeStartY;
      isGallerySwipe = true;
    }, { passive: true, capture: true });

    gallery.addEventListener('touchmove', function (event) {
      if (!isGallerySwipe || !event.touches.length) return;
      var touch = event.touches[0];
      swipeLastX = touch.clientX;
      swipeLastY = touch.clientY;
    }, { passive: true, capture: true });

    gallery.addEventListener('touchend', function () {
      if (!isGallerySwipe) return;
      var deltaX = swipeLastX - swipeStartX;
      var deltaY = swipeLastY - swipeStartY;
      isGallerySwipe = false;

      if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY) * 1.25) return;
      setActiveMedia(currentMediaIndex + (deltaX < 0 ? 1 : -1));
    }, { passive: true, capture: true });
  }

  function syncQuantities(value) {
    root.querySelectorAll('[data-spp-qty-input]').forEach(function (input) {
      input.value = value;
    });
  }

  root.querySelectorAll('[data-spp-qty-input]').forEach(function (input) {
    input.addEventListener('input', function () {
      syncQuantities(Math.max(1, parseInt(input.value || '1', 10)));
    });
  });

  root.querySelectorAll('form[data-spp-product-form], form[data-spp-sticky-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      var variantInput = form.querySelector('[data-spp-variant-input]');
      if (!variantInput || !variantInput.value) {
        event.preventDefault();
        guideCaliberSelection();
        return;
      }

      event.preventDefault();
      var submit = form.querySelector('[data-spp-add]');
      var originalText = submit ? submit.textContent : '';
      var data = new FormData(form);
      var qty = Math.max(1, parseInt(data.get('quantity') || '1', 10));
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Adding...';
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart add failed');
          return response.json();
        })
        .then(function (item) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                source: 'product-form-component',
                itemCount: qty,
                variantId: item.id,
                productId: item.product_id
              }
            }
          }));
          if (submit) submit.textContent = 'Added';
          setTimeout(function () {
            if (submit) submit.textContent = originalText;
          }, 1600);
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (submit) submit.disabled = false;
          updateSelectedVariant();
        });
    });
  });

  var faqSearch = root.querySelector('[data-spp-faq-search]');
  if (faqSearch) {
    var faqItems = Array.prototype.slice.call(root.querySelectorAll('.spp-faq-item'));
    function updateFaqResults(query) {
      var visibleCount = 0;
      faqItems.forEach(function (item) {
        var isExtra = item.hasAttribute('data-spp-faq-extra');
        var matches = !query ? !isExtra : item.textContent.toLowerCase().includes(query);
        item.hidden = !matches;
        if (matches) {
          if (query) item.open = visibleCount === 0;
          visibleCount += 1;
        }
      });
      var empty = root.querySelector('[data-spp-faq-empty]');
      if (empty) empty.hidden = visibleCount > 0;
    }

    faqSearch.addEventListener('input', function () {
      var query = faqSearch.value.toLowerCase().trim();
      updateFaqResults(query);
    });
    updateFaqResults('');
  }

  var sticky = root.querySelector('[data-spp-sticky-atc]');
  var scrollTimer;
  var lastY = window.scrollY;
  function updateStickyVisibility() {
    if (!sticky || window.matchMedia('(min-width: 750px)').matches) return;
    var movingDown = window.scrollY > lastY;
    sticky.classList.toggle('is-hidden', movingDown);
    lastY = window.scrollY;
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      sticky.classList.remove('is-hidden');
    }, 220);
  }
  window.addEventListener('scroll', updateStickyVisibility, { passive: true });

  var description = root.querySelector('[data-spp-product-description]');
  var descriptionIcon = root.querySelector('[data-spp-description-icon]');
  function updateDescriptionIcon() {
    if (descriptionIcon && description) descriptionIcon.textContent = description.open ? '-' : '+';
  }
  function syncDescriptionState() {
    if (!description) return;
    updateDescriptionIcon();
  }
  syncDescriptionState();
  if (description) description.addEventListener('toggle', updateDescriptionIcon);

  var modal = root.querySelector('[data-spp-modal]');
  function closeModal() {
    if (modal) modal.hidden = true;
  }
  function openModal() {
    if (!modal) return;
    modal.hidden = false;
    var close = modal.querySelector('[data-spp-modal-close]');
    if (close) close.focus();
  }
  root.querySelectorAll('[data-spp-modal-open]').forEach(function (button) {
    button.addEventListener('click', openModal);
  });
  root.querySelectorAll('[data-spp-modal-close]').forEach(function (button) {
    button.addEventListener('click', closeModal);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeModal();
  });

  function normalizeReviewText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function getJudgeReviewRating(reviewNode) {
    var ratingNode = reviewNode.querySelector('[data-score]');
    var score = Number(ratingNode && ratingNode.getAttribute('data-score'));
    var filledStars = reviewNode.querySelectorAll('.jdgm-rev__rating .jdgm-star.jdgm--on, .jdgm-rev__rating .jdgm-star.jdgm--half').length;
    var rating = filledStars || score || 5;
    return Math.max(1, Math.min(5, Math.round(rating)));
  }

  function extractJudgeReview(reviewNode) {
    var bodyNode = reviewNode.querySelector('.jdgm-rev__body');
    var titleNode = reviewNode.querySelector('.jdgm-rev__title');
    var authorNode = reviewNode.querySelector('.jdgm-rev__author');
    var locationNode = reviewNode.querySelector('.jdgm-rev__location');
    var body = normalizeReviewText(bodyNode && bodyNode.textContent);
    var title = normalizeReviewText(titleNode && titleNode.textContent);
    var author = normalizeReviewText(authorNode && authorNode.textContent) || 'Verified buyer';
    var location = normalizeReviewText(locationNode && locationNode.textContent).replace(/[()]/g, '');
    var copy = body || title;

    if (!copy || copy.length < 8) return null;
    if (copy.length > 155) {
      copy = copy.slice(0, 152).replace(/\s+\S*$/, '') + '...';
    }

    return {
      rating: getJudgeReviewRating(reviewNode),
      copy: copy,
      buyer: 'Verified buyer - ' + author + (location ? ' / ' + location : '')
    };
  }

  function buildProductReviewCard(review) {
    var card = document.createElement('article');
    var stars = document.createElement('div');
    var copy = document.createElement('p');
    var buyer = document.createElement('strong');

    card.className = 'spp-review-card';
    stars.textContent = '★★★★★'.slice(0, review.rating);
    stars.setAttribute('aria-label', review.rating + ' out of 5 stars');
    copy.textContent = review.copy;
    buyer.textContent = review.buyer;

    card.appendChild(stars);
    card.appendChild(copy);
    card.appendChild(buyer);
    return card;
  }

  var track = root.querySelector('[data-spp-review-track]');
  var judgeSource = root.querySelector('[data-spp-judge-source]');
  function hydrateProductReviewCards() {
    if (!track || !judgeSource || track.getAttribute('data-product-reviews-loaded') === 'true') return;
    var seenReviews = {};
    var productReviews = Array.prototype.slice.call(judgeSource.querySelectorAll('.jdgm-rev'))
      .map(extractJudgeReview)
      .filter(function (review) {
        if (!review) return false;
        var key = review.buyer + '|' + review.copy;
        if (seenReviews[key]) return false;
        seenReviews[key] = true;
        return true;
      });

    if (productReviews.length) {
      track.innerHTML = '';
      productReviews.slice(0, 10).forEach(function (review) {
        track.appendChild(buildProductReviewCard(review));
      });
      track.setAttribute('data-product-reviews-loaded', 'true');
    }
  }
  hydrateProductReviewCards();
  if (track && judgeSource && track.getAttribute('data-product-reviews-loaded') !== 'true' && window.MutationObserver) {
    var reviewObserver = new MutationObserver(hydrateProductReviewCards);
    reviewObserver.observe(judgeSource, { childList: true, subtree: true });
  }

  if (track) {
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    track.addEventListener('pointerdown', function (event) {
      isDown = true;
      startX = event.pageX;
      scrollLeft = track.scrollLeft;
      track.setPointerCapture(event.pointerId);
    });
    track.addEventListener('pointermove', function (event) {
      if (!isDown) return;
      track.scrollLeft = scrollLeft - (event.pageX - startX);
    });
    track.addEventListener('pointerup', function () { isDown = false; });
    track.addEventListener('pointercancel', function () { isDown = false; });

    var reviewStep = function () {
      var card = track.querySelector('.spp-review-card');
      if (!card) return 320;
      var style = window.getComputedStyle(track);
      return card.getBoundingClientRect().width + parseFloat(style.columnGap || style.gap || 0);
    };
    var prevReview = root.querySelector('[data-spp-review-prev]');
    var nextReview = root.querySelector('[data-spp-review-next]');
    if (prevReview) prevReview.addEventListener('click', function () {
      track.scrollBy({ left: -reviewStep(), behavior: 'smooth' });
    });
    if (nextReview) nextReview.addEventListener('click', function () {
      track.scrollBy({ left: reviewStep(), behavior: 'smooth' });
    });
  }

  setActiveMedia(0);
  updateSelectedVariant();
})();
